// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions / selectors
import { setChartId } from './chart-id.actions';
import { setFundChart } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const chartId = createReducer(null, on(setChartData, (state, { chartData }) => chartData.params.chartId), on(setChartId, (state, action) => action.chartId), on(setFundChart, (state, { fundChart }) => fundChart.chartId));
